import React from 'react'
import classNames from 'classnames'
import type { IProgressBarProps } from './interfaces'
import './styles.scss'

const ProgressBar = ({ percentage, className, hidePercentage = false }: IProgressBarProps) => (
  <div className={classNames('progressBar', { 'progressBar--compact': hidePercentage }, className)}>
    <div className="progressBar__indicator" style={{ width: `${percentage}%` }} />
    {!hidePercentage && <span className="progressBar__value text_super-small">{percentage}%</span>}
  </div>
)

export default ProgressBar
